import React from 'react';
import PropTypes from 'prop-types';

const RegistryCollectionHeader = ({ collection, count, enableCustomCollections }) =>
  enableCustomCollections ? (
    <div className="collection-header row">
      {collection.image_url && (
        <div className="col-md-2 col-sm-4 hidden-xs collection-image">
          <img src={collection.image_url} className="img-responsive" alt={collection.title} />
        </div>
      )}
      <div className="col-md-10 col-sm-8 col-xs-12 collection-details">
        <h3>{collection.title}</h3>
        <p>{collection.description}</p>
      </div>
    </div>
  ) : (
    <div className="col-xs-12">
      <h2 className="product-count text-center visible-xs visible-sm">
        {collection.title}{' '}
        <small className="text-muted">
          {count} {count > 1 ? 'Items' : 'Item'}
        </small>
      </h2>
      <div className="grid-controls form-inline">
        <h2 className="product-count with-title hidden-xs hidden-sm">
          {collection.title}{' '}
          <small className="text-muted">
            {count} {count > 1 ? 'Items' : 'Item'}
          </small>
        </h2>
      </div>
    </div>
  );

RegistryCollectionHeader.propTypes = {
  collection: PropTypes.shape({
    description: PropTypes.string,
    image_url: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
  count: PropTypes.number,
  enableCustomCollections: PropTypes.bool,
};

export default RegistryCollectionHeader;



// WEBPACK FOOTER //
// ./src/components/registry/RegistryCollectionHeader.jsx